<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="银行流水" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
								<el-form-item label="银行流水号">
									<el-input v-model="searchForm.num" placeholder="请填写银行流水号"></el-input>
								</el-form-item>
								<el-form-item label="对方名称">
									<el-input v-model="searchForm.others_name" placeholder="请填写对方名称"></el-input>
								</el-form-item>
								<el-form-item label="对方银行账号">
									<el-input v-model="searchForm.others_account" placeholder="请填写对方银行账号"></el-input>
								</el-form-item>
								<el-form-item label="开户行">
									<el-input v-model="searchForm.bank" placeholder="请填写开户行"></el-input>
								</el-form-item>
								<el-form-item label="类型">
									<el-select v-model="searchForm.type" placeholder="请选择类型" clearable>
										<el-option v-for="item in options.type_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<!-- <el-form-item label="状态">
								    <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
								        <el-option
								          v-for="item in options.status_options"
								          :key="item.value"
								          :label="item.label"
								          :value="item.value">
								        </el-option>
								      </el-select>
								</el-form-item> -->
								<el-form-item label="资金性质">
									<el-select v-model="searchForm.nature" placeholder="请选择资金性质" clearable>
										<el-option v-for="item in options.nature_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="状态">
									<el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
										<el-option v-for="item in options.status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="交易日期">
									<el-date-picker v-model="searchForm.time" type="daterange" format="yyyy-MM-dd"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="doSearch">查询</el-button>
									<el-button type="primary" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;"
								v-if="$parent.$parent.isAuthAction('admin/news/message/importline') || $parent.$parent.isAuthAction('admin/news/message/createline')">
								<div>
									<el-button type="primary" size="mini" @click="uploadOpen()"
										v-if="$parent.$parent.isAuthAction('admin/news/message/importline')">导入银行流水</el-button>
									<el-button type="primary" size="mini" @click="addBanklineOpen()"
										v-if="$parent.$parent.isAuthAction('admin/news/message/createline')">新增银行流水</el-button>
								</div>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" style="width: 100%" border stripe ref="table" highlight-current-row
									@sort-change="sortChange" :height="tableHeight">
									<el-table-column fixed prop="id" label="ID" min-width="50">
									</el-table-column>
									<el-table-column prop="num" label="银行流水号" min-width="200">
									</el-table-column>
									<el-table-column prop="trade_date" label="交易日期" width="200">
									</el-table-column>
									<el-table-column prop="type_name" label="类型" width="80">
									</el-table-column>
									<el-table-column prop="nature_name" label="资金性质" width="100">
									</el-table-column>
									<el-table-column prop="code_num" label="开户行" min-width="200">
									</el-table-column>
									<el-table-column prop="others_account" label="对方银行账号" width="200">
									</el-table-column>
									<el-table-column prop="others_name" label="对方名称" min-width="250">
									</el-table-column>
									<el-table-column prop="money" label="金额" width="120">
									</el-table-column>
									<el-table-column prop="content" label="摘要" min-width="180">
									</el-table-column>
									<!-- <el-table-column
								        prop="unmatched_money"
								        label="未匹配金额"
								        width="120"
								        >
								</el-table-column> -->
									<!-- <el-table-column
								        prop="code_num"
								        label="责任编码"
								        min-width="150"
								        >
								</el-table-column>
								<el-table-column
								        prop="code_name"
								        label="责任中心名称"
								        min-width="100"
								        >
								</el-table-column> -->
									<el-table-column prop="create_time" label="创建日期" min-width="180">
									</el-table-column>
									<el-table-column fixed="right" prop="status_name" label="状态" width="80"
										:filters="[{ text: '未知', value: '1' }, { text: '未匹配', value: '2' }, { text: '部分匹配', value: '3' }, { text: '已匹配', value: '4' }]"
										:filter-method="filterPaystatus">
									</el-table-column>
									<el-table-column fixed="right" label="操作" align="center" width="100">
										<template slot-scope="scope">
											<el-button :disabled="scope.row.status == 3 || scope.row.status == 4"
												@click="handleTableEditOpen(scope.row)" type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/news/message/editline')">编辑</el-button>
											<el-button :disabled="scope.row.status == 3 || scope.row.status == 4"
												@click="handleTableDelete(scope.row)" type="text" size="small" class="c-danger"
												v-if="$parent.$parent.isAuthAction('admin/news/message/delbankline')">
												删除
											</el-button>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--导入银行流水-->
		<el-dialog title="导入银行流水" :visible.sync="uploadFormVisiable" :close-on-click-modal="false" v-loading="loading"
			width="40%">
			<el-form :model="uploadForm" ref="uploadForm" :size="size" :rules="rules.uploadForm" label-width="130px">
				<div>
					<el-form-item label="银行流水文件:" prop="excel_file">
						<el-upload drag ref="upload_excel_file" accept=".xls,.xlsx" action
							:http-request="(file) => { return imggreySuccess(file, 'excel_file_files') }"
							:file-list="uploadForm.excel_file_list" :on-remove="(file) => handleRemoveUpload(file, 'excel_file_list')"
							:auto-upload="false" :on-exceed="limitMessage" :limit='1'>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text" style="font-size: 12px;">将文件拖到此处，或<em>点击上传</em><br /><span>支持 .xls
									.xlsx</span>
							</div>
							<div class="el-upload__tip" slot="tip"><a @click="downloadTemplate()" target="_blank"
									style="color: #409EFF; font-size: 12px;"><i class="el-icon-download"></i> 文件模板下载</a></div>
						</el-upload>
					</el-form-item>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addbankline" :size='size'>提交</el-button>
				<el-button :size='size' @click="uploadFormVisiable = false">取消</el-button>
			</span>
		</el-dialog>
		<!--新增银行流水-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" :close-on-press-escape='false'
			:wrapperClosable='false' size="50%">
			<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="140px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>新增银行流水</span>
						<i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="银行流水号" prop="num">
						<el-input v-model="addForm.num" placeholder="请填写银行流水号" clearable maxlength="20" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="流水类型" prop="type">
						<el-select v-model="addForm.type" placeholder="请选择流水类型" clearable>
							<el-option v-for="item in options.type_options" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开户行" prop="bank">
						<el-input v-model="addForm.bank" placeholder="请填写开户行" clearable maxlength="20" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="金额(元)" prop="money">
						<el-input v-model="addForm.money" placeholder="请填写金额" clearable></el-input>
					</el-form-item>
					<el-form-item label="对方账户名" prop="others_name">
						<el-input v-model="addForm.others_name" placeholder="请填写对方账户名" clearable maxlength="30"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="对方账号" prop="others_account">
						<el-input v-model="addForm.others_account" placeholder="请填写对方账号" clearable maxlength="30"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="交易日期" prop="trade_date">
						<el-date-picker v-model="addForm.trade_date" type="datetime" format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择交易时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="资金性质" prop="nature">
						<el-select v-model="addForm.nature" placeholder="请选择资金性质" clearable>
							<el-option v-for="item in options.nature_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="摘要">
						<el-input type="textarea" v-model="addForm.content" placeholder="请填写摘要" clearable maxlength="100"
							show-word-limit></el-input>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="addBankline()" :size='size'>提交</el-button>
					<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!--编辑银行流水-->
		<el-drawer custom-class="k-drawer" :visible.sync="editFormVisiable" direction="rtl" :close-on-press-escape='false'
			:wrapperClosable='false' size="50%">
			<el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="140px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>新增银行流水</span>
						<i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="银行流水号" prop="num">
						<el-input v-model="editForm.num" placeholder="请填写银行流水号" clearable maxlength="20" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="流水类型" prop="type">
						<el-select v-model="editForm.type" placeholder="请选择流水类型" clearable>
							<el-option v-for="item in options.type_options" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开户行" prop="bank">
						<el-input v-model="editForm.bank" placeholder="请填写开户行" clearable maxlength="30" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="金额(元)" prop="money">
						<el-input v-model="editForm.money" placeholder="请填写金额" clearable></el-input>
					</el-form-item>
					<el-form-item label="对方账户名" prop="others_name">
						<el-input v-model="editForm.others_name" placeholder="请填写对方账户名" clearable maxlength="30"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="对方账号" prop="others_account">
						<el-input v-model="editForm.others_account" placeholder="请填写对方账号" clearable maxlength="30"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="交易时间" prop="trade_date">
						<el-date-picker v-model="editForm.trade_date" type="datetime" format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择交易时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="资金性质" prop="nature">
						<el-select v-model="editForm.nature" placeholder="请选择资金性质" clearable>
							<el-option v-for="item in options.nature_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="摘要">
						<el-input type="textarea" v-model="editForm.content" placeholder="请填写摘要" clearable maxlength="100"
							show-word-limit></el-input>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="editBankline()" :size='size'>提交</el-button>
					<el-button :size='size' @click="editFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		return {
			loading: false,
			uploadFormVisiable: false,
			editFormVisiable: false,
			addFormVisiable: false,
			editFormVisiable: false,
			activeName: 'first',
			size: 'mini',
			options: {
				status_options: [
					{
						value: 1,
						label: '未知'
					}, {
						value: 2,
						label: '未匹配'
					}, {
						value: 3,
						label: '部分匹配'
					}, {
						value: 4,
						label: '已匹配'
					}
				],
				nature_options: [
					{
						value: 0,
						label: '未知'
					}, {
						value: 1,
						label: '供应商付款'
					}, {
						value: 2,
						label: '供应商返点'
					}, {
						value: 3,
						label: '客户返点'
					}, {
						value: 4,
						label: '项目收款'
					}, {
						value: 5,
						label: '供应商退款'
					}, {
						value: 6,
						label: '客户退款'
					}, {
						value: 7,
						label: '框架政策返点'
					}
				],
				status_options: [
					{
						value: 1,
						label: '未知'
					}, {
						value: 2,
						label: '未匹配'
					}, {
						value: 3,
						label: '部分匹配'
					}, {
						value: 4,
						label: '已匹配'
					}
				],
				type_options: [
					{
						value: 0,
						label: '未知'
					}, {
						value: 1,
						label: '收款'
					},
					//    {
					// 	 value: 2,
					// 	 label: '付款'
					//    }, 
					{
						value: 3,
						label: '退款'
					}
				],
			},
			searchForm: {
				others_name: '',
				others_account: '',
				bank: '',
				type: '',
				status: '',
				nature: '',
				num: '',
				time: '',
				status: ''
			},
			resetSearch: {
				others_name: '',
				others_account: '',
				bank: '',
				type: '',
				status: '',
				nature: '',
				num: '',
				time: '',
				status: ''
			},
			addForm: {
				num: '',
				type: '',
				bank: '',
				money: '',
				trade_date: '',
				others_name: '',
				others_account: '',
				nature: '',
				content: ''
			},
			editForm: {
				num: '',
				type: '',
				bank: '',
				money: '',
				trade_date: '',
				others_name: '',
				others_account: '',
				nature: '',
				content: ''
			},
			rules: {
				uploadForm: {
					'excel_file': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.uploadForm.excel_file_files.length < 1 && this.uploadForm.excel_file_list.length < 1) {
									callback(new Error('请上传银行流水'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					]
				},
				addForm: {
					'num': [
						{ required: true, message: '请填写银行流水号', trigger: ['change', 'blur'] }
					],
					'type': [
						{ required: true, message: '请选择流水类型', trigger: ['change', 'blur'] }
					],
					'bank': [
						{ required: true, message: '请填写开户行', trigger: ['change', 'blur'] }
					],
					'money': [
						{ required: true, message: '请填写金额', trigger: ['change', 'blur'] }
					],
					'trade_date': [
						{ required: true, message: '请选择交易日期', trigger: ['change', 'blur'] }
					],
					'others_name': [
						{ required: true, message: '请填写对方账户名', trigger: ['change', 'blur'] }
					],
					'others_account': [
						{ required: true, message: '请填写对方账号', trigger: ['change', 'blur'] }
					],
					'nature': [
						{ required: true, message: '请选择资金类型', trigger: ['change', 'blur'] }
					]
				},
				editForm: {
					'num': [
						{ required: true, message: '请填写银行流水号', trigger: ['change', 'blur'] }
					],
					'type': [
						{ required: true, message: '请选择流水类型', trigger: ['change', 'blur'] }
					],
					'bank': [
						{ required: true, message: '请填写开户行', trigger: ['change', 'blur'] }
					],
					'money': [
						{ required: true, message: '请填写金额', trigger: ['change', 'blur'] }
					],
					'trade_date': [
						{ required: true, message: '请选择交易日期', trigger: ['change', 'blur'] }
					],
					'others_name': [
						{ required: true, message: '请填写对方账户名', trigger: ['change', 'blur'] }
					],
					'others_account': [
						{ required: true, message: '请填写对方账号', trigger: ['change', 'blur'] }
					],
					'nature': [
						{ required: true, message: '请选择资金类型', trigger: ['change', 'blur'] }
					]
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
			uploadForm: {
				excel_file_list: [],//银行流水
				excel_file_files: [],
				excel_file: '',
			},
		}
	},
	computed: {

		tableHeight: function () {
			return window.innerHeight - 320;
		},
		apiMainHeight: function () {
			var height = window.innerHeight - 180;
			return { height: height + 'px', border: '1px solid #DCDFE6', 'margin-bottom': '10px' }
		},
	},
	mounted: function () {
		this.handleSearch(this.searchForm);
	},
	methods: {
		filterPaystatus (value, row) {
			return row.status == value;
		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		downloadTemplate: function () {
			this.$api.get('/admin/customers/export/exporttemplate', { 'file_name': '银行收付款明细.xlsx' }).then(res => {
				// 将Blob转换为URL以便创建一个可下载的链接
				const url = window.URL.createObjectURL(new Blob([res]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', '银行收付款明细.xlsx'); // 设置下载文件名
				document.body.appendChild(link);
				link.click(); // 触发点击下载
				document.body.removeChild(link); // 下载后移除元素
				window.URL.revokeObjectURL(url); // 释放URL对象
			})
		},
		reset: function () {
			this.searchForm = this.resetSearch;
			this.doSearch();
		},
		handleSearch: function (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/news/message/banklinelist', param).then(res => {
				if (res.code === 0) {
					this.tableData = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})

		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		// 打开导入银行流水
		uploadOpen () {
			this.uploadForm.excel_file_list = []
			this.$nextTick(() => {
				this.$refs['uploadForm'].clearValidate();
			});
			this.uploadFormVisiable = true;
		},
		//导入银行流水
		addbankline () {
			if (this.$refs.upload_excel_file) {
				this.uploadForm.excel_file_files = []
				this.$refs.upload_excel_file.submit()
			}
			const formData = new FormData()
			//银行流水
			if (this.uploadForm.excel_file_files.length > 0) {
				this.uploadForm.excel_file_files.forEach(item => {
					formData.append('excel_file', item)
				})
			}
			this.$refs['uploadForm'].validate(function (valid) {
				if (valid) {
					this.loading = true
					this.$api.post('/admin/news/message/importline', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '银行流水导入成功！',
								type: 'success'
							});
							this.uploadFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				} else {
					this.$message.error('请填写正确的信息！');
				}
			}.bind(this));
		},
		// 删除银行流水
		handleTableDelete (row) {
			this.$confirm('此操作将永久删除该银行流水, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/news/message/delbankline', { id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$delete(data, index);
							} else if (item.children) {
								item.children.forEach(function (value, key) {
									if (value.id == row.id) {
										this.$delete(item.children, key);
									}
								}.bind(this));
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该银行流水已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		limitMessage: function (files, fileList) {
			this.$message({
				showClose: true,
				message: `本次选择了 ${files.length} 个文件,超出最大要求数量限制`,
				type: 'warning'
			})
		},
		imggreySuccess: function (files, field) {
			this.uploadForm[field].push(files.file)
		},
		changeRequired (file, formgroup, formobj) {
			this.uploadForm[formgroup][formobj] = 1
		},
		handleRemoveUpload (file, formobj) {
			this.uploadForm[formobj] = []
		},
		// 打开编辑银行流水弹窗
		handleTableEditOpen (row) {
			this.editForm = {
				num: '',
				type: '',
				bank: '',
				money: '',
				trade_date: '',
				others_name: '',
				others_account: '',
				nature: '',
				content: ''
			}
			this.$api.get('/admin/news/message/getline', { id: row.id }).then(res => {
				if (res.code === 0) {
					this.editForm = res.data
					this.editFormVisiable = true;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		// 编辑银行流水
		editBankline () {
			this.$refs['editForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/news/message/editline', this.editForm).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '银行流水信息修改成功！',
								type: 'success'
							});
							this.editFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				}
			}.bind(this));
		},
		//新增银行流水弹窗
		addBanklineOpen () {
			this.addForm = {
				num: '',
				type: '',
				bank: '',
				money: '',
				trade_date: '',
				others_name: '',
				others_account: '',
				nature: '',
				content: ''
			}
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			this.addFormVisiable = true;
		},
		// 新增银行流水
		addBankline () {
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/news/message/createline', this.addForm).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '银行流水新增成功！',
								type: 'success'
							});
							this.addFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
	}
}
</script>